var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-sn",attrs:{"id":"app"}},[_c('side-nav'),_c('div',{staticClass:"flexible-content"},[_c('navbar',{attrs:{"page":_vm.activePage}}),_c('main',[_c('div',[_c('router-view',{key:_vm.$route.path})],1)]),_c('div',{staticClass:"white-skin"},[_c('copyrights')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }